import { gsap } from 'gsap';

import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

class SvdS {
	constructor() {
		window.addEventListener('DOMContentLoaded', (event) => {
			this.init();
		});

		this.breakpoint = window.matchMedia('(min-width: 992px)');

		// Store references to timelines and ScrollTriggers
		this.timelines = [];
		this.scrollTriggers = [];

		// Listen for breakpoint changes
		this.breakpoint.addEventListener('change', () => {
			this.destroyAnimations();
			this.init();
		});
	}

	init() {
		this.stepAnimations = document.querySelectorAll('[data-steps]');

		this.steps = [];
		this.stepAnimations.forEach((animation) => {
			const svgs = animation.querySelectorAll('svg');
			svgs.forEach((svg) => {
				const steps = svg.querySelectorAll('g');
				this.steps.push(...steps);
			});
		});

		this.setInitialState();
		if (this.breakpoint.matches) {
			this.initLinearStepsAnimation();
		} else {
			this.initStepAnimations();
		}
	}
	destroyAnimations() {
		// Kill all timelines
		this.timelines.forEach((tl) => tl.kill && tl.kill());
		this.timelines = [];
		// Kill all ScrollTriggers
		if (window.ScrollTrigger && ScrollTrigger.getAll) {
			ScrollTrigger.getAll().forEach((st) => st.kill());
		}
		this.scrollTriggers = [];
		// Optionally reset state
		if (this.steps && this.steps.length) {
			gsap.set(this.steps, { autoAlpha: 0, scale: 0.95 });
		}
	}

	setInitialState() {
		gsap.set(this.steps, {
			autoAlpha: 0,
			scale: 0.95,
		});
	}

	initStepAnimations() {
		this.stepAnimations.forEach((animation, index) => {
			const svg = animation.querySelector('svg');
			const steps = svg.querySelectorAll('g');

			let start = animation.dataset.start || 'top 70%';
			if (index === 0 && this.breakpoint.matches) {
				start = 'top ' + steps[0].getBoundingClientRect().top + 'px';
			}
			const duration = animation.dataset.duration || 0.666;

			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: svg,
					start: start,
					end: () => {
						return '+=' + window.innerHeight * duration;
					},
					scrub: true,
				},
			});
			this.timelines.push(tl);
			if (tl.scrollTrigger) {
				this.scrollTriggers.push(tl.scrollTrigger);
			}

			steps.forEach((step) => {
				tl.to(step, {
					autoAlpha: 1,
					scale: 1,
					delay: 0.08,
					duration: 0.1,
					ease: 'none',
				});
			});
		});
	}

	initLinearStepsAnimation() {
		const tl = gsap.timeline({
			scrollTrigger: {
				trigger: this.steps[0],
				start: () => {
					return 'top ' + this.steps[0].getBoundingClientRect().top + 'px';
				},
				endTrigger: this.steps[this.steps.length - 1],
				end: 'bottom 50%',
				scrub: 0.5,
			},
		});
		this.timelines.push(tl);
		if (tl.scrollTrigger) {
			this.scrollTriggers.push(tl.scrollTrigger);
		}

		this.steps.forEach((step) => {
			tl.to(step, {
				autoAlpha: 1,
				scale: 1,
				delay: 0.08,
				duration: 0.1,
				ease: 'none',
			});
		});
	}
}

// Initialize the SvdS class
new SvdS();
